(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["oph-new-footer"]) return;
  try {
    

(() => {

  /*
   * ---------------------------------------------------------
   * FOOTER
   * ---------------------------------------------------------
   *
   * Do not use {{ section.id }} here.
   * Shopify compiles {% javascript %} separately.
   */

  const footer = document.querySelector('.foot');

  if (!footer) return;


  const card = footer.querySelector('.foot__card');

  if (!card) return;


  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;


  /*
   * ---------------------------------------------------------
   * MOBILE FOOTER ACCORDIONS
   * ---------------------------------------------------------
   *
   * Reference behavior:
   * - Desktop: headings are not interactive.
   * - Mobile: headings expand/collapse their column.
   */

  const headings = footer.querySelectorAll('.col__h');

  headings.forEach((heading) => {

    heading.addEventListener('click', () => {

      if (
        window.matchMedia('(min-width:900px)').matches
      ) {
        return;
      }


      const isOpen =
        heading.getAttribute('aria-expanded') === 'true';


      heading.setAttribute(
        'aria-expanded',
        String(!isOpen)
      );

    });

  });


  /*
   * ---------------------------------------------------------
   * BACK TO TOP
   * ---------------------------------------------------------
   */

  const topButton = footer.querySelector(
    '.foot__top-btn'
  );


  if (topButton) {

    topButton.addEventListener('click', () => {

      window.scrollTo({
        top: 0,
        behavior: reduceMotion
          ? 'auto'
          : 'smooth'
      });

    });

  }

})();


  } catch(e) { console.error(e); }
})();
})();
